<template>
  <div class="container">
    <nyTit1 pathUrl="/yingyangcan" />
    <div class="content">
      <!-- 左侧 -->
      <div class="leftBox">
        <div class="title">
          <span class="txt1">三产融合</span
          ><span class="txt2">Integration of three industries</span>
        </div>
        <!-- 红薯市场分析 -->
        <div class="leftBox1">
          <div class="title1">红薯市场分析</div>
          <div class="leftContent1">
            <div class="leftContent1_item"  v-for="(item, index) in state.leftData1"  :key="index">
              <span class="leftContent1_item_name">{{ item.name }}</span>
              <span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
              <span class="leftContent1_item_percent">{{ item.percent}}<i>{{ item.percentVal}}%</i></span>
            </div>
          </div>
        </div>
        <div class="leftBox4">
          <div class="title1">近5年红薯价格走势</div>
          <div class="echartBox"><leftLine  /></div>
        </div>
        <!-- 今日红薯价格行情 -->
        <div class="leftBox2">
          <div class="title1">近日红薯价格行情</div>
          <div class="echartBox"><leftLine2 :left2Data="state.left2Data" v-if="state.left2Data.time.length>0"  /></div>
          
        </div>
        <!-- 上蔡县红薯产业现状 -->
        <div class="leftBox3">
          <div class="title1">上蔡县红薯产业现状</div>
          <div class="leftContent1">
            <div class="leftContent1_item"  v-for="(item, index) in state.leftData4"  :key="index">
              <span class="leftContent1_item_name">{{ item.name }}</span>
              <span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
            </div>
          </div>
          <div class="leftContent3"><img src="../assets/img/sanchan1/zt.png" />2011年被认定为全国地理标志性农产品</div>
        </div>
        <!-- 过去6年丝瓜总产值 -->
        <!-- <div class="leftBox4">
            <div class="title1">过去6年丝瓜总产值</div>
            <div class="echartBox"><leftBar :datas="leftData3" /></div>
          </div> -->
      </div>
      <!--中间-->
      <div class="center">
        <div class="jian_kong_fc1"><span>红薯产业链场景展示</span></div>
        <div class="centerList">
          <div class="centerItem" v-for="(item,index) in state.optionArr" :key="index">
            <div class="img1 img">
              <vue3VideoPlay v-if="item.type==1" id="video" ref="videoRef" width="100%" height="100%" title="视频监控" :src="item.options.src" :type="item.options.type" :autoPlay="false" :muted="true" :control="false" @loadedmetadata="onLoadedMetadata" />
              <div class="iframe" v-else>
                <iframe  v-if="item.videoShow" :src="item.options.src + store.state.AccessToken" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
                <img :src="item.img" v-else @click="videoShow(index)" />
              </div>

              <div class="jian_kong_fc">最状元直播间</div>
            </div>
            <img src="../assets/img/sanchan1/jt.png" class="jiantou" />
          </div>
        </div>



<!--        <div class="img2 img">-->
<!--          &lt;!&ndash; <img src="../assets/img/sanchan1/cp.jpg" /> &ndash;&gt;-->
<!--          <vue3VideoPlay-->
<!--            id="video"-->
<!--            ref="videoRef"-->
<!--            width="100%"-->
<!--            height="100%"-->
<!--            title="视频监控"-->
<!--            :src="state.options1.src"-->
<!--            :type="state.options1.type"-->
<!--            :autoPlay="false"-->
<!--            :muted="true"-->
<!--            :control="false"-->
<!--            @loadedmetadata="onLoadedMetadata"-->
<!--          />-->
<!--          <div class="jian_kong_fc">最状元酸辣粉加工基地</div>-->
<!--        </div>-->
<!--        <img src="../assets/img/sanchan1/jt.png" class="jiantou" />-->
<!--        <div class="img3 img">-->
<!--&lt;!&ndash;          <vue3VideoPlay&ndash;&gt;-->
<!--&lt;!&ndash;            id="video"&ndash;&gt;-->
<!--&lt;!&ndash;            ref="videoRef"&ndash;&gt;-->
<!--&lt;!&ndash;            width="100%"&ndash;&gt;-->
<!--&lt;!&ndash;            height="100%"&ndash;&gt;-->
<!--&lt;!&ndash;            title="视频监控"&ndash;&gt;-->
<!--&lt;!&ndash;            :src="state.options2.src"&ndash;&gt;-->
<!--&lt;!&ndash;            :type="state.options2.type"&ndash;&gt;-->
<!--&lt;!&ndash;            :autoPlay="false"&ndash;&gt;-->
<!--&lt;!&ndash;            :muted="true"&ndash;&gt;-->
<!--&lt;!&ndash;            :control="false"&ndash;&gt;-->
<!--&lt;!&ndash;            @loadedmetadata="onLoadedMetadata"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->
<!--          <div style=" width: 100%;height: 100%"  v-if="state.videoSHow3[3]">-->
<!--            <iframe-->
<!--              :src="state.options2.src+store.state.AccessToken"-->
<!--              width="100%"-->
<!--              height="100%"-->
<!--              id="ysOpenDevice"-->
<!--              allowfullscreen-->
<!--            >-->
<!--            </iframe>-->
<!--          </div>-->
<!--          <img src="../assets/img/sanchan1/video3.jpg" v-else @click="videoShow(index)" />-->
<!--          <div class="jian_kong_fc">红薯种植基地</div>-->
<!--        </div>-->
      </div>
      <!-- 右侧 -->
      <div class="rightBox">
        <div class="rightBox1">
          <div class="title">
            <span class="txt1">发展路径</span
            ><span class="txt2">Development path</span>
          </div>
          <div></div>
          <div class="rightContent1">
            <div class="rightContent1_item" v-for="(item,index) in state.rightData1" :key="index"><span>{{item}}</span></div>
          </div>

          <!-- 六个产品导航开始 -->
          <!-- <div class="dao_hang">
            <div
              class="biao_ti_name"
              v-for="(item, index) in tData6"
              :key="index"
            >
              <router-link :to="{ path: item.path }"  >{{ item.name }}</router-link> 
            </div>
          </div> -->
          <!-- 六个产品导航结束 -->
        </div>
        <div class="rightBox2">
          <div class="rightBox2_1">
            <div class="title1 rightTit">擦亮品牌</div>
            <div class="rightBox2_1_content">
              <div class="rightBox2_1_content_item"><img src="../assets/img/sanchan1/hongshu.png" /><h5>崇礼红薯</h5></div>
              <div class="rightBox2_1_content_item"><img src="../assets/img/sanchan1/caipanzi.png" /><h5>蔡盘子</h5></div>
              <div class="rightBox2_1_content_item"><img src="../assets/img/sanchan1/zhuangyuan.png" /><h5>最状元</h5></div>
            </div>
          </div>
          <div class="rightBox2_2">
            <div class="title1 rightTit">电商赋能</div>
            <div class="rightBox2_2_content"><dv-scroll-board :config="state.config"  style="width: 100%; height: 100%"   /></div>
          </div>
          <div class="rightBox2_3">
            <div class="title1 rightTit">以销助产</div>
            <div class="leftContent1">
            <div class="leftContent1_item"  v-for="(item, index) in state.rightData3"  :key="index">
              <span class="leftContent1_item_name">{{ item.name }}</span>
              <span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
            </div>
          </div>
          </div>
          <div class="rightBox2_4">
            <div class="title1 rightTit">以产促种</div>
            <div class="leftContent1">
            <div class="leftContent1_item"  v-for="(item, index) in state.rightData4"  :key="index">
              <span class="leftContent1_item_name">{{ item.name }}</span>
              <span class="leftContent1_item_value">{{ item.value }}<i>{{ item.unit }}</i></span>
            </div>
          </div>
          </div>

        </div>
      </div>
    </div>
  </div>
<!--  <footer1 />-->
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";
import { useRouter } from "vue-router";
import countTo from "@/components/vue-count-to/src/vue-countTo.vue";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
  inject
} from "vue";
import { useStore } from "vuex";
//
import nyTit1 from '@/components/nyTit1.vue'
import leftPie from "@/components/sanchan1/left_pie";
import leftBar from "@/components/sanchan1/left_bar";
import rightPie from "@/components/sanchan1/right_pie";

import leftLine from "@/components/sanchan1_hongshu/left_line";
import leftLine2 from "@/components/sanchan1_hongshu/left_line3";


import footer1 from "../components/footer.vue";


// const AccessToken = inject('AccessToken')
const { appContext } = getCurrentInstance();
const store = useStore();
const timer = ref(null);
const router = useRouter();
const state = reactive({
  url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
  left2Data:{time:[],data:[]},
  leftData1: [
    { name: "中国红薯种植面积", value: 9000, unit: "万亩",percent:"占全球",percentVal:70 },
    { name: "中国红薯产量", value: 1, unit: "亿吨",percent:"占全球",percentVal:80 },
    { name: "河南红薯产量", value: 3000, unit: "万吨" ,percent:"占国",percentVal:30 },
  ],
  leftData4: [
    { name: "红薯种植历史", value: 400, unit: "年"},
    { name: "红薯种植面积", value: 4, unit: "万亩" },
    { name: "红薯产量", value: 12.7, unit: "万吨" },
    { name: "全产业链产值", value: 7.9, unit: "亿元" },
  ],
  videoSHow3:[true,false,false],
  optionArr:[
    {
      type:1,
      videoShow:true,
      img:"",
      options: {
        src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sgsp/hs02.mp4", //视频源
        type: "video/mp4", //视频类型
      }
    },{
      type:2,
      videoShow:false,
      img:require('../assets/img/sanchan1/video2.jpg'),
      // options: {
      //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/sgsp/ft.mp4", //视频源
      //   type: "video/mp4", //视频类型
      // },
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2501929/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
    },{
      type:2,
      videoShow:false,
      img:require('../assets/img/sanchan1/video3.jpg'),
      options: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2455304/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
    }
  ],


  rightData1:["擦亮品牌", "电商赋能"," 以销助产"," 以产促种"],
  config: {
    header: [ '时间','GMV','流量','订单量','转化率'],
    data: [
      ['2023-03-25','<span style="color:#8FBDDC;">1.96W</span>',"4.5W","659","8%"],
      ['3-24','<span style="color:#8FBDDC;">1.86W</span>',"4.2W","586","7%"],
      ['3-23','<span style="color:#8FBDDC;">2.06W</span>',"5.2W","686","10%"],
      ['3-22','<span style="color:#8FBDDC;">2.26W</span>',"5.3W","700","11.2%"],
      ['3-21','<span style="color:#8FBDDC;">1.94W</span>',"4.3W","627","9.6%"],
      ['3-20','<span style="color:#8FBDDC;">2.26W</span>',"5.6W","700","8.6%"],
    ],
    headerBGC: "#1B4764",
    headerHeight:"60",
    oddRowBGC: "",
    evenRowBGC: "",
    // columnWidth: [50],
    align: ["center", "center", "center", "center"],
    rowNum: 4,
  },
  rightData3: [
    { name: "年产红薯粉丝", value: 400, unit: "吨"},
    { name: "年产酸辣粉饼", value: 230, unit: "吨" },
    { name: "年收益", value: 610, unit: "万元" },
  ],
  rightData4: [
    { name: "已签订种植订单", value: 74, unit: "笔"},
    { name: "种植面积", value: 1400, unit: "亩" },
    { name: "预计红薯产量", value: 4300, unit: "吨" },
  ],
  tData6: [
    { name: "丝瓜水" ,path:"/sanchan1"},
    { name: "红薯" ,path:"/sanchan1_hongshu"},
    { name: "营养餐" },
    { name: "黄姜" },
    { name: "食用菌" },
    { name: "醋" },
  ],

});
onMounted(() => {
  // store.commit('getToken')
  // setInterval(() => {
  //   state.showDiv = !state.showDiv
  // }, 6000);
  // 使用示例
  let dates = getPreviousDates(6); // 获取今日之前的5个日期
  let configData = state.config.data
  for (var i = 0; i < configData.length; i++){
    state.config.data[i][0] = dates[i]
  }
  getData()
  store.commit('getToken')
  // console.log(store.state.AccessToken)
});
onUnmounted(() => {});
onBeforeUnmount(() => {});
// 返回上一页
function videoShow(index){
  state.optionArr[index].videoShow = true
}
function getData() {
  axios
    .post("https://sckshadmin.laicunwang.com/api/index/index", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
    .then((res) => {
      // console.log(res);
      state.left2Data.time = res.data.data.d2
      state.left2Data.data = res.data.data.d1
      // console.log(state.left2Data)

    });
}
    function tabcp(e) {
      console.log(e.rowIndex);
    }
    // 获取今日之前的日期
    function getPreviousDates(days) {
      let today = new Date();
      let previousDates = [];

      for (let i = 0; i < days; i++) {
        let date = new Date(today);
        date.setDate((today.getDate()-1) - i);
        console.log(date)
        // let month = specificDate.getMonth();
        let item = (date.getMonth()+1) + '-' +date.getDate();
        previousDates.push(item)
        // previousDates.push(date.toISOString().split('T')[0]);
      }

      return previousDates;
    }
</script>
<style lang="less" scoped>
a {
  color: #fff;
}
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("../assets/font/DS-DIGIT.TTF");
}

#video .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}

// 修改右侧产品带货列表列表样式
::v-deep .dv-scroll-board .rows .row-item,
::v-deep .dv-scroll-board .header {
  font-size: 26px;
}
::v-deep .dv-scroll-board .rows .row-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.container {
  width: 100%;
  height: 100vh;
  background: url("../assets/img/sanchan1/bj.jpg") no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;
  .content {
    position: absolute;
    top: 150px;
    left: 0;
    width: 100%;
    height: calc(100vh - 150px);
    display: flex;
    position: relative;
    padding: 0 45px 100px;
    box-sizing: border-box;
    // 左侧
    .leftBox,
    .rightBox {
      width: 780px;
    }
    .leftBox {
      height: 100%;
      background: url("../assets/img/sanchan1/z1.png") no-repeat;
      background-size: 100% 100% !important;
      display: flex;
      flex-direction: column;
      .leftBox1 {
        width: 100%;
        height: 260px;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
      }
      .leftBox2 {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        margin: 20px 0;
      }
      .leftBox3{
        height: 300px;
        display: flex;
        flex-direction: column;
        .leftContent1{
          margin-top: 40px;
        }
        .leftContent3{
          width: 90%;
          padding: 15px 0 15px 30px;
          box-sizing: border-box;
          background: #042446;
          margin: 30px auto 30px;
          font-size: 30px;
          display: flex;
          align-items: center;
          color: #DEAB4B;
          font-weight: bold;
          img{
            width: 50px;
            height: 50px;
            margin-right: 20px;
          }
        }
      }
      .leftBox4 {
        width: 100%;
        height: 390px;

        display: flex;
        flex-direction: column;
        margin-top: 15px;
      }
    }
    .center {
      flex: 1;
      flex-shrink: 0;
      height: 100%;
      padding-top: 240px;
      box-sizing: border-box;
      display: flex;
      margin: 0 120px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .centerList{
        display: flex;
        width: 100%;
        height: 100%;
        .centerItem{
          display: flex;
          align-items: center;
          .iframe{
            width: 100%;
            height: 100%;
          }
        }
        .centerItem:last-child{
          .jiantou{
            display: none;
          }
        }
      }
      .jian_kong_fc1 {
          width: 100%;
          height: 90px;
          background: rgba(7, 72, 112, 0.2);
          position: absolute;
          top: 8%;
          left:0%;
          z-index: 999;
          span{
            font-size: 60px;
            line-height: 100px;
            z-index: 999;
            background: linear-gradient(180deg, #fff 25%, #abdfff 95%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 700;
            letter-spacing: 20px;
          }
          
        }
      .img {
        width: 1380px;
        background: url("../assets/img/sanchan1/zk.png") no-repeat;
        height: 100%;
        background-size: 100% 100% !important;
        padding: 43px 36px;
        box-sizing: border-box;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .jian_kong_fc {
          width: 95%;
          height: 90px;
          background: rgba(7, 72, 112, 0.8);
          position: absolute;
          top: 0.5%;
          left: 2.5%;
          font-size: 30px;
          line-height: 90px;
          z-index: 999;
        }
      }
      .jiantou {
        width: 73px;
        height: 88px;
        margin: 0 20px;
      }
    }
    // 右側
    .rightBox {
      height: 100%;
      display: flex;
      flex-direction: column;
      a{
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;      
        }
      .rightBox1 {
        width: 100%;
        height: 286px;
        background: url("../assets/img/sanchan1/y1.png") no-repeat;
        display: flex;
        flex-direction: column;

        .rightContent1 {
          padding: 20px 50px;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          font-size: 30px;
          justify-content: space-between;
          width: 90%;
          .rightContent1_item{
            width: 46%;
            height: 80px;
            line-height: 80px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            background: #1B4764;
            position: relative;
            span{
              display: block;
              width: 100%;
              height: 100%;
              position: relative;
            }
             span::before{
            content: "";
            width: 18px;
            height: 2px;
            background: #04F1EA;
            position: absolute;
            right: 0;
            bottom: 0;
          }
          span::after{
            content: "";
            width: 2px;
            height: 20px;
            background: #04F1EA;
            position: absolute;
            right: 0;
            bottom: 0;
          }
          }
          .rightContent1_item::before{
            content: "";
            width: 18px;
            height: 2px;
            background: #04F1EA;
            position: absolute;
            top: 0;
            left: 0;
          }
          .rightContent1_item::after{
            content: "";
            width: 2px;
            height: 20px;
            background: #04F1EA;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .dao_hang {
          width: 130px;
          height: 400px;
          position: absolute;
          display: flex;
          flex-direction: column;
          right: 20px;
          top: -5px;
          z-index: 1;
          .biao_ti_name {
            width: 100%;
            flex: 1;
            margin: 8px 0;
            background-color: #0e4275;
            position: relative;
            a{
              display: block; 
              font-size: 25px;
              line-height: 48px;
              width: 100%;
              height: 100%;
              color: #fff;
              position: absolute;
            }
          }
        }
      }
      .rightBox2 {
        width: 100%;
        flex: 1;
        margin-top: 22px;
        background: url("../assets/img/sanchan1/y2.png") no-repeat;
        background-size: 100% 100%!important;
        display: flex;
        flex-direction: column;
        .rightTit {
          margin: 30px 40px 30px;
        }
        .rightBox2_1{
          display: flex;
          flex-direction: column;
          .rightBox2_1_content{
            display: flex;
            justify-content: space-between;
            padding: 0 50px;
            .rightBox2_1_content_item{
              box-shadow: inset 0 0 5px 5px #1B4764;
              border: 1px solid #1B4764;
              border-radius: 10px;
              font-size: 30px;
              width: 200px;
              color: #00ffea;
              // display: flex;
              // align-items: center;
              padding: 20px 0;
              img{
                width: 100px;
                height: 100px;
              }
            }
          }
        }
        .rightBox2_2{
          height: 400px;
          display: flex;
          flex-direction: column;
          .rightBox2_2_content{
            flex: 1;
            width: 100%;
            padding: 0 20px;
          }
          // border: 1px solid;
        }
        .rightBox2_3,.rightBox2_4{
          height: 200px;
          display: flex;
          flex-direction: column;
          margin: 0 0 20px;
        }
      }
    }
    .echartBox {
      width: 100%;
      flex: 1;
    }

    // 标题
    .title {
      width: 100%;
      height: 60px;
      background: url("../assets/img/sanchan1/xbt.png") no-repeat;
      text-align: left;
      padding-left: 50px;
      line-height: 60px;
      .txt1 {
        font-size: 34px;
        background: linear-gradient(to bottom, #fff 25%, #abdfff 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-style: italic;
        font-weight: bold;
        padding: 0 10px;
      }
      .txt2 {
        color: #0287ba;
        margin-left: 40px;
        font-size: 26px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
      }
    }
    .title1 {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: url("../assets/img/sanchan1/zb.png") no-repeat left bottom;
      color: #d2e2f2;
      font-size: 30px;
      text-align: left;
      margin-left: 40px;
      padding-left: 20px;
      box-sizing: border-box;
      font-weight: bold;
    }
  }
}
.leftContent1 {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-top: 30px;
  .leftContent1_item {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    .leftContent1_item_name {
      font-size: 24px;
      color: #d0deee;
      line-height: 30px;
    }
    .leftContent1_item_value {
      font-size: 40px;
      color: #00ffea;
      margin-top: 5px;
      i {
        font-size: 24px;
        color: #d0deee;
        margin-left: 10px;
      }
    }
    .leftContent1_item_percent{
      font-size: 24px;
      color: #d0deee;
      margin-top: 10px;
      i{
        font-size:30px;
        color: #DEBA59;
        margin-left: 10px;
      }
    }
  }
}
// 轨道旋转动画b
@keyframes spin {
  0% {
    transform: scaleY(0.5) rotate(0deg);
  }
  100% {
    transform: scaleY(0.5) rotate(360deg);
  }
}
@keyframes anti-spin {
  0% {
    transform: rotate(0deg) scaleY(2) scale(1);
  }
  100% {
    transform: rotate(-360deg) scaleY(2) scale(1);
  }
}
// 轨道

@keyframes scale1 {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50%,
  75% {
    transform: scale(2);
  }
  78%,
  100% {
    opacity: 0;
  }
}
@keyframes title {
  0% {
    background-position: 0 bottom;
  }
  50% {
    background-position: 10px bottom;
  }
  100% {
    background-position: 0 bottom;
  }
}
@keyframes bianda {
  0% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
  50% {
    // transform: scale(1);
    filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
  }
  100% {
    // transform: scale(0.96);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0));
  }
}
@keyframes jiantou {
  0% {
    right: 90px;
  }

  50% {
    right: 95px;
  }
  100% {
    right: 90px;
  }
}

@keyframes guangying {
  0% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }

  50% {
    transform: scale(1);
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5));
  }
  100% {
    transform: scale(0.96);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
}

@keyframes rightCircle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  0% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(0deg) rotateY(0deg) rotateZ(360deg);
  }
}

// 左侧矩形
@keyframes leftJx {
  /*引用动画名称*/
  0% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
  50% {
    box-shadow: inset 0 0 10px 2px rgba(55, 199, 219, 0.5);
  }

  100% {
    box-shadow: inset 0 0 5px 2px rgba(55, 199, 219, 0.5);
  }
}
</style>
